import type { User } from 'firebase/auth';

/** Display initials for avatar fallback: first letter of displayName, email, or "U". */
export function getUserInitials(user: User): string {
  return user.displayName?.[0] || user.email?.[0] || 'U';
}

/** Display name for UI, falls back to "User". */
export function getDisplayName(user: User): string {
  return user.displayName || 'User';
}

/** Alt text for user photo. */
export function getPhotoAlt(user: User): string {
  return getDisplayName(user);
}
